<label class="checkbox-type">
  <input name="checkBoxName" type="checkbox" [(ngModel)]="value" [disabled]="!!disabled" (change)="onSaveModel()">
  <span *ngIf="name" [className]="disabled ? 'input-name disabled': 'input-name' ">{{name}}</span>
</label>